export enum ReservationServiceTypeEnum {
  EJECUTIVO = "Ejecutivo",
  VIP = "VIP",
  UTILITARIO = "Utilitario",
}

export const RESERVATION_SERVICE_TYPE = Object.values(
  ReservationServiceTypeEnum
).sort();
